import gql from 'graphql-tag';

import { waitForAllReturnWhenError, query, queryAgg } from '@confluence/query-preloader-tools';
import { AccessStatus } from '@confluence/session-data';

import { preloadPersonalizedTemplatesV2OnboardingState } from './preloadPersonalizedTemplatesV2OnboardingState';
import { preloadNthUserHomeOnboardingRevampState } from './nth-user-home-onboarding/preloadNthUserHomeOnboardingRevampState';

export const GetPersonalSpaceDetailQuery = gql`
	query preloadPersonalizedTemplatesGetPersonalSpaceDetailQuery {
		user: confluence_atlassianUser(current: true) {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;

export const AllTemplatesQuery = gql`
	query preloadPersonalizedTemplatesAllTemplatesQuery {
		allTemplates(usePersonalSpace: true) {
			nodes {
				templateId
				contentBlueprintId
				blueprintModuleCompleteKey
				itemModuleCompleteKey
				name
			}
		}
	}
`;

export const SubAnchorQuery = gql`
	query preloadPersonalizedTemplatesSubAnchorQuery($accountId: ID!) {
		growthUnifiedProfile_getUnifiedProfile(accountId: $accountId) {
			paidChannelContext {
				confluence {
					subAnchor
				}
			}
		}
	}
`;

export const LicensedUserCountQuery = gql`
	query preloadPersonalizedTemplatesLicensedUserCountQuery {
		license {
			licenseConsumingUserCount
		}
	}
`;

export const preloadPersonalizedTemplates = (userId: string, accessStatus: AccessStatus) => {
	return waitForAllReturnWhenError([
		query({ query: GetPersonalSpaceDetailQuery }),
		query({
			query: AllTemplatesQuery,
			variables: {
				usePersonalSpace: true,
			},
		}),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [
					queryAgg({
						query: SubAnchorQuery,
						variables: {
							accountId: userId || '',
						},
					}),
				]
			: []),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [preloadPersonalizedTemplatesV2OnboardingState()]
			: []),
		preloadNthUserHomeOnboardingRevampState(),
		query({ query: LicensedUserCountQuery }),
	]);
};
